<div>
    <div class="flex justify-center py-4">
        <svg width="106" height="117" viewBox="0 0 106 117" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M74.0049 23.325L58.7525 11.805C55.3515 9.23619 50.6589 9.2362 47.2578 11.805L32.0055 23.325L13.8482 29.8366C9.49901 31.3963 6.89367 35.8495 7.6651 40.405L10.6508 58.0367L7.6651 75.6684C6.89366 80.2239 9.49902 84.6771 13.8482 86.2368L32.0055 92.7484L47.2578 104.268C50.6589 106.837 55.3515 106.837 58.7525 104.268L74.0049 92.7484L92.1622 86.2368C96.5114 84.6771 99.1167 80.2239 98.3453 75.6684L95.3595 58.0367L98.3453 40.405C99.1167 35.8495 96.5114 31.3963 92.1622 29.8366L74.0049 23.325Z"
                fill="#FFEDE3" stroke="#FFF5F5" stroke-width="13.6229" />
            <circle cx="52" cy="57" r="10" stroke="#DC0032" stroke-width="2" fill="#FFEDEE" />
            <line x1="47" y1="52" x2="57" y2="62" stroke="#DC0032" stroke-width="2" stroke-linecap="round" />
            <line x1="57" y1="52" x2="47" y2="62" stroke="#DC0032" stroke-width="2" stroke-linecap="round" />

        </svg>
    </div>
    <div>
        <p class=" font-semibold text-black text-center margin-horizontal-50">
            {{ 'FORM.ORDER_IS_CANCELLED' | transloco }}
        </p>
    </div>
    <div class="gap-4 flex justify-center mt-[10px] bg-[#F8F9FA] py-8 px-6">
        <button class="py-3 px-8 rounded-lg  font-medium text-sm leading-6 bg-[#DC0032] text-white"
            [mat-dialog-close]="true">
            OK
        </button>
    </div>
</div>